<template>
       <span data-goods-discount>
        <span  style="display:none">
            <!-- 价格显示区域 -->
             <div :class="[isFuture ?'discount-nostart' : 'discount-start','discount-timer']" ref="timer" v-show="isFuture||isDiscount">
                <dl class="discount-timer-left" v-if="isFuture">
                   <dt class="discount-timer-price">
                     <!--<span class="name"></span>-->
                     <span class="ks">Ks</span>
                     <span class="integer">{{countPrice|$convertPrice|priceFormat}}</span>
                     <!--<span class="pointer">.</span>-->
                     <!--<span class="decimal">{{currentPrice|$convertPrice|getDecimal}}</span>-->
                   </dt>
                   <!--<dd class="discount-price-sign">-->
                     <!--<div class="sign"><i></i><span class="sign-title">{{currentGoodsInfo.promotionTypeText}}</span></div>-->
                     <!--<div class="old-price">Ks{{oldPrice|$convertPrice}}</div>-->
                   <!--</dd>-->
                </dl>

                <dl class="discount-timer-right">
                    <!--<dt class="timer-text">{{isFuture ? "距活动开始还有" :"距活动结束"}}</dt>-->
                    <dd class="timer-upside" ref="countdown"></dd>
                </dl>
            </div>
          <!-- end 价格显示区域 -->
        </span>
         <div style="background:#fff" v-if="isFuture||isDiscount">

         <!--&lt;!&ndash; 限时折扣未开始 &ndash;&gt;-->
           <!--<div v-if="isFuture" class="detail-item" style="border-top:0.05rem solid #eee">-->
             <!--<div class="goods-batch">-->
                  <!--<div class="goods-batch-price">-->
                      <!--<em>Ks{{oldPrice|$convertPrice|priceFormat}}</em>-->
                  <!--</div>-->
             <!--</div>-->
               <!--<dl class="discount">-->
                 <!--<dt class="discount-text">价格</dt>-->
                   <!--<dd class="discount-price no-price">未开始</dd>-->
               <!--</dl>-->
               <!--<dl class="discount">-->
                 <!--<dt class="discount-text">描述</dt>-->
                   <!--<dd class="discount-price">{{ discount.discountExplain  ?discount.discountExplain  : "暂无描述"   }}</dd>-->
               <!--</dl>-->
               <!--<dl class="discount">-->
                 <!--<dt class="discount-text">时间</dt>-->
                   <!--<dd class="discount-time" >-->
                    <!--<em>{{discount.startTime|$convertDate}}</em>至<em>{{discount.endTime|$convertDate}}</em>-->
                   <!--</dd>-->
               <!--</dl>-->
            <!--</div>-->
            <!--&lt;!&ndash; 限时折扣已经开始 &ndash;&gt;-->
            <div v-if="isDiscount" class="detail-item" style="border-top:0.05rem solid #eee">
               <div class="goods-batch">
                  <div class="goods-batch-price">
                      <em>Ks{{currentPrice|$convertPrice|priceFormat}}</em>
                  </div>
                  <div style="width: 100%;    padding-bottom: 1rem;">
                  <div class="old-price"  style=" display: inline-block;font-size: 0.64rem;  float: left;text-decoration: line-through;color: #CCCCCC;">Ks{{oldPrice|$convertPrice|priceFormat}}</div>
                  <div style="display: inline-block;font-size: 0.64rem;color: #CCCCCC;float: left;"> |&ensp;{{100 - (info.promotionDiscountRate * 10)}}%OFF</div></div>
              </div>
               <!--<dl class="discount">-->
                 <!--<dt class="discount-text">价格</dt>-->
                   <!--<dd class="discount-price"><i>Ks</i><em class="retainage">{{currentPrice|$convertPrice}}</em></dd>-->
               <!--</dl>-->
               <!--<dl class="discount">-->
                   <!--<dt class="discount-text">描述</dt>-->
                   <!--<dd class="discount-price">{{discount.discountExplain  ?discount.discountExplain  : "暂无描述"  }}</dd>-->
               <!--</dl>-->
               <!--<dl class="discount">-->
                   <!--<dt class="discount-text">时间</dt>-->
                   <!--<dd class="discount-time" >-->
                   <!--<em>{{discount.startTime|$convertDate}}</em>至<em>{{discount.endTime|$convertDate}}</em>-->
                   <!--</dd>-->
               <!--</dl>-->
            </div>
         </div>



        <!--<span style="display:none">-->
            <!--&lt;!&ndash; 价格显示区域 &ndash;&gt;-->
             <!--<div :class="[isFuture ?'discount-nostart' : 'discount-start','discount-timer']" ref="showPricePanel" v-show="isFuture||isDiscount">-->
                 <!--<div class="goods-batch">-->
                   <!--<div class="goods-batch-price">-->
                     <!--<em>Ks{{currentPrice|$convertPrice|getInteger}}</em>-->
                   <!--</div>-->
                   <!--<div style="width: 100%;    padding-bottom: 1.5rem;">-->
                     <!--<div class="old-price"  style=" display: inline-block;font-size: 0.6rem;  float: left;text-decoration: line-through;margin-right: 0.4rem ;color: #CCCCCC;">Ks{{oldPrice|$convertPrice}}</div>-->
                     <!--<div style="display: inline-block;font-size: 0.6rem;color: #F3B202;float: left;">{{discount.discountRate*10}} %OFF</div></div>-->
                 <!--</div>-->
                <!--</div>-->
        <!--</span>-->
    </span>
</template>
<script>

    /**
     * 限时折扣相关
     */
    export default {
        //外部传入参数
        props: {
            // 当前sku信息
            discount: {
                type: Object,
                required: false
            },
            currentGoodsInfo: {
                type: Object,
                required: true
            },
            //价格显示区域
            showPriceElement: {
                type: String,
                required: true
            } ,
            //限时折扣是否开始
            timeType:{
                type: String,
                required: false
            } ,
            wechat:{
                required: false
            },
            app:{
                required: false
            },
            info:{
              type: Object,
              required: true
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                showDialog: false,
                showDialogFirst: true,
                scrollInstance: null
            }
        },
        /**
         * 计算属性
         */
        computed: {
            /**
             * 是否已经开始
             */
            isStarted: function () {
                if (!this.isDiscount){
                   return false
                }
                return this.timeType == "ongoing"
            },
            /**
             * 限时活动是否开始
             */
            isFuture:function(){
                var _currentInfo = this.currentGoodsInfo
                return !Nc.isEmpty(this.discount) && this.timeType == 'future' && this.wechat && _currentInfo.promotionType == 1
            },
            /**
             * 原价格batchPrice0
             */
            oldPrice: function () {
                return this.info.batchPrice0;
            },
            /**
             * 活动价格wechatPrice0
             */
            currentPrice: function () {
                return this.currentGoodsInfo.wechatPrice0;
            },
            /**
             * 計算折後價
             */
            countPrice: function () {
              return this.currentGoodsInfo.appPrice0 * (this.discount.discountRate / 10);
            },
            /**
             * 倒计时
             */
            endTimeUnix: function () {
                return Nc.isEmpty(this.discount) ? 0 : this.discount.promotionCountDownTime
            },
            /**
             * 是否是限时折扣
             */
            isDiscount: function () {
                var _currentInfo = this.currentGoodsInfo ,
                        _isUsable = this.wechat
                        ;
                return  　_isUsable && !Nc.isEmpty(this.discount) && this.discount.promotionCountDownTime > 0 && this.isUsable && _currentInfo.promotionType == 1
            },
            /**
             * 标识是否有活动
             */
            isUsable: function () {
                return getUsable(this.currentGoodsInfo)
            }
        },

        /**
         * 监听属性变动
         */
        watch: {
            showDialog: function (value) {
                var self = this;
                if (value) {
                    this.$nextTick(function () {
                        if (!self.scrollInstance) {
                            self.scrollInstance = new IScroll(self.$refs.scroll, {
                                scrollX: false,
                                scrollY: true,
                                click: false
                            });
                        } else {
                            self.scrollInstance.refresh()
                        }
                    })
                }
            }
        },
        /**
         * 过滤器
         */
        filters: {
            /**
             * 只获取日期
             */
            getDayOnly: function (value) {
                return value.split(" ")[0];
            },
            /**
             *  获取价格的整数
             */
            getInteger: function (value) {
                return value.split(".")[0]
            },
            /**
             * 获取价格的
             */
            getDecimal: function (value) {
                return value.split(".")[1]
            },
            priceFormat:function (value) {
                return Nc.priceFormat(value);
           }

        },

        mounted() {
            var self = this,

                    $body, $target, $timer;
            console.log('isDiscount')
            //移动元素
//            if (this.isDiscount ||this.isFuture ) {
                $timer = this.$refs.timer;

                //移动价格显示
                $target = document.querySelectorAll(this.showPriceElement);
                if ($target.length) {
                    $target[0].appendChild($timer)
                }
//            }
            //添加倒计时
            this.refreshCountDown()
            //发送事件
//            this.$emit("updated")
        },
        updated() {
            this.$emit("updated")
        },

        /**
         * 自定义方法
         */
        methods: {
            //刷新倒计时
            refreshCountDown: function () {
                var _endTimeUnix = this.endTimeUnix;
                if (_endTimeUnix > 0) {
                    $(this.$refs.countdown).ncCountDown({
                        time: _endTimeUnix,
                        cndays: "timer-day",
                        cnminutes: "timer-hours",
                        cnallHours: 'timer-hours',
                        cnhours: 'timer-hours',
                        cnseconds: 'timer-hours',
                        unitDay: "<i>:</i>",
                        unitHour: "<em>:</em>",
                        unitMinute: "<em>:</em>",
                        unitSecond: "",
                        warp: "span",
                        hideDay: false,
                        end: function () {
                            Nc.go();
                        }
                    });
                }
            },
            //去除无关的touch事件
            excludeTouch: function (event) {
                event.preventDefault();
                return false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-discount/goods-discount.vue